import React from "react";
import { Link } from "react-router-dom";

// Text-based FesX logo with a stylized blue "X" mark
const Logo = ({ variant = "dark", size = "md" }) => {
  const sizes = {
    sm: { box: "h-8 w-8", text: "text-lg", sub: "text-[9px]" },
    md: { box: "h-10 w-10", text: "text-xl", sub: "text-[10px]" },
    lg: { box: "h-12 w-12", text: "text-2xl", sub: "text-[11px]" },
  };
  const s = sizes[size] || sizes.md;
  const textColor = variant === "light" ? "text-white" : "text-slate-900";
  const subColor = variant === "light" ? "text-blue-200" : "text-blue-600";

  return (
    <Link to="/" className="flex items-center gap-2.5 group">
      <div
        className={`${s.box} relative rounded-lg bg-gradient-to-br from-blue-600 to-blue-700 flex items-center justify-center shadow-md shadow-blue-600/20 transition-transform group-hover:scale-105`}
      >
        <span className={`fesx-x text-white ${s.text} leading-none`}>X</span>
        <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-sky-400 ring-2 ring-white" />
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-extrabold tracking-tight ${s.text} ${textColor}`}>
          Fes<span className="text-blue-600">X</span>
        </span>
        <span className={`${s.sub} font-semibold uppercase tracking-[0.18em] ${subColor}`}>
          Peptides
        </span>
      </div>
    </Link>
  );
};

export default Logo;
